// Avatar neutro para pacientes sin foto. Es un SVG embebido (data:), no una URL externa: así no
// se le filtra la IP de la doctora a ningún tercero y funciona sin conexión.
// Antes, el valor por defecto de HeaderPaciente apuntaba a https://i.pravatar.cc (un servicio
// externo de avatares de prueba), aunque en la práctica nunca se renderizaba.
export const PLACEHOLDER_PACIENTE =
  "data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23e0e0e0'%3e%3cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/%3e%3c/svg%3e";
